import React from 'react';
import ContentWrapper from '../Wrappers/ContentWrapper/ContentWrapper';
import FormFields from './FormFields/FormFields';
import { useApp } from 'Shared/utils/hooks/use-app';

type Props = {
  profile: {
    email: string;
  };
  forceToDesktop: boolean;
  cannotSignIntoGoogle: boolean;
  includeNameField?: boolean;
  description?: string;
};

function CreateAccount({
  profile,
  forceToDesktop,
  cannotSignIntoGoogle,
  includeNameField,
  description = 'Sign up now to save all of the workspaces you’ve created',
}: Props) {
  const {
    app: {
      routes: { signUpUrl },
    },
  } = useApp();

  return (
    <ContentWrapper
      isSignUpTab
      initialValues={{
        user: { email: profile.email, password: '' },
      }}
      title="Almost there!"
      actionUrl={signUpUrl}
      description={description}
    >
      <FormFields
        includeNameField={includeNameField}
        forceToDesktop={forceToDesktop}
        cannotSignIntoGoogle={cannotSignIntoGoogle}
      />
    </ContentWrapper>
  );
}

export default CreateAccount;
